/**
 * Language Switcher Component
 * Coláiste Lurgan Management System - Toggle between English and Irish
 */

import { useTranslation } from 'react-i18next';
import { Button } from './button';
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger 
} from './dropdown-menu';
import { Globe } from 'lucide-react';

export function LanguageSwitcher({ variant = "ghost", size = "sm" }) {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const currentLanguage = i18n.language;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={size}>
          <Globe className="h-4 w-4 mr-2" />
          {currentLanguage === 'ga' ? 'GA' : 'EN'}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem 
          onClick={() => changeLanguage('en')}
          className={currentLanguage === 'en' ? 'bg-accent' : ''}
        >
          <span className="mr-2">🇬🇧</span>
          English
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => changeLanguage('ga')}
          className={currentLanguage === 'ga' ? 'bg-accent' : ''}
        >
          <span className="mr-2">🇮🇪</span>
          Gaeilge
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default LanguageSwitcher;